/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileBom = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4zm11 3.414V7h1.586z" />
        <path d="M7 17v-4.871h1.708c.621 0 1.077.105 1.367.315.295.21.443.536.443.978 0 .219-.059.415-.175.59s-.277.312-.482.415c.576.179.864.56.864 1.146 0 .951-.659 1.427-1.976 1.427zm1.005-2.854h.51c.352 0 .6-.045.743-.134.147-.094.221-.25.221-.47 0-.227-.071-.386-.214-.475-.143-.094-.393-.14-.75-.14h-.51zm0 2.05h.663c.344 0 .597-.054.757-.16s.242-.276.242-.503c0-.224-.08-.387-.242-.49-.16-.102-.413-.154-.757-.154h-.663zm5.483.898c-.728 0-1.291-.22-1.689-.657-.393-.442-.59-1.068-.59-1.876 0-.8.2-1.42.597-1.863.398-.442.958-.663 1.682-.663s1.284.221 1.681.663c.398.443.597 1.063.597 1.863 0 .808-.197 1.434-.59 1.876-.393.438-.956.657-1.688.657zm0-.891c.406 0 .708-.141.904-.423.201-.28.302-.687.302-1.219s-.1-.936-.302-1.213c-.196-.281-.498-.422-.904-.422-.407 0-.71.141-.911.422-.197.277-.295.681-.295 1.213s.098.938.294 1.22c.201.28.505.422.912.422zm3.065.797v-4.871h1.092l1.548 3.21 1.527-3.21h1.092v4.87H20.78v-3.155l-1.286 2.687h-.643l-1.287-2.647V17z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileBom as FileBom };
